import $ from 'jquery';
import { AUTH_KEY, APIBASE } from '~/constant';

let connection = null;
let hubProxy = null;
let conectado = false;
let signalRCarregado = false;

const carregarSignalR = () =>
  new Promise((resolve, reject) => {
    if (signalRCarregado) return resolve();
    window.jQuery = $;
    window.$ = $;
    const script = document.createElement('script');
    script.src = '/jquery.signalR-2.4.3.min.js';
    script.onload = () => {
      signalRCarregado = true;
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });

export const conectar = async (onAtualizarContador, onReceberMensagem, onReceberComunicado) => {
  if (conectado) return;

  const token = localStorage.getItem(AUTH_KEY);
  if (!token) return;

  try {
    await carregarSignalR();
  } catch (err) {
    console.error('SignalR: erro ao carregar script', err);
    return;
  }

  connection = $.hubConnection(APIBASE, { useDefaultPath: true });
  connection.qs = { bearer_token: token };

  hubProxy = connection.createHubProxy('ChatDepartamentoHub');

  hubProxy.on('AtualizarContador', () => {
    if (onAtualizarContador) onAtualizarContador();
  });

  hubProxy.on('ReceberMensagem', codigoConversa => {
    if (onReceberMensagem) onReceberMensagem(codigoConversa);
  });

  hubProxy.on('ReceberComunicado', codigoComunicado => {
    if (onReceberComunicado) onReceberComunicado(codigoComunicado);
  });

  connection
    .start()
    .done(() => {
      conectado = true;
      console.log('SignalR ChatDepartamento: conectado');
    })
    .fail(err => {
      console.error('SignalR ChatDepartamento: erro ao conectar', err);
    });
};

export const desconectar = () => {
  if (connection && conectado) {
    connection.stop();
    conectado = false;
    connection = null;
    hubProxy = null;
  }
};

export const isConectado = () => conectado;
